<template>
  <!--父表-->
  <div id="tableComps">

    <div class="toptableComps_header">
      <slot name="topTopFunction" ></slot>
    </div>

    <div class="tableComps_header">

      <slot name="topFunction"></slot>

      <a-dropdown v-if="tableFuncionSearch  && !embeddedTableMode ">
        <a class="ant-dropdown-link">
          <img src="../../assets/img/ss-more.png"  width="15" height="15">
        </a>
        <a-menu slot="overlay">
          <a-menu-item style="font-size: 12px" @click="AdvanceSearch">
            <a-icon type="zoom-in" /> {{ $t('pubGicSet.AdvanceSearch') }}
          </a-menu-item>
          <a-menu-item style="font-size: 12px" @click="searchSort">
            <a-icon type="ordered-list" /> {{ $t('pubGicSet.AdvanceSort') }}
          </a-menu-item>
          <a-menu-item v-if="this.systemParam.ENABLE_USER_COLUMN_SETTING == 'Y'" style="font-size: 12px" @click="columnSetting">
            <a-icon type="table" /> Column Setting
          </a-menu-item>
          <a-sub-menu>
            <span slot="title"><a-icon type="lock" /> {{ $t('pubGicSet.FreezeCol') }}:</span>
            <a-menu-item @click="handleChange(0)">{{ $t('pubGicSet.Clear') }}</a-menu-item>
            <a-menu-item @click="handleChange(1)">1</a-menu-item>
            <a-menu-item @click="handleChange(2)">2</a-menu-item>
            <a-menu-item @click="handleChange(3)">3</a-menu-item>
            <a-menu-item @click="handleChange(4)">4</a-menu-item>
            <a-menu-item @click="handleChange(5)">5</a-menu-item>
            <a-menu-item @click="handleChange(6)">6</a-menu-item>
          </a-sub-menu>
        </a-menu>
      </a-dropdown>
    </div>
    <!--表格-->
    <a-row style="position: relative;">
      <!-- 正常区域的框 -->
      <div  v-if="!embeddedTableMode"  class="vxe-table--cell-area" ref="cellarea">
        <span class="vxe-table--cell-main-area"></span>
        <span class="vxe-table--cell-active-area"></span>
      </div>
      <!-- 左边fixed区域的框,右边fixed没有尝试过。。。 -->
      <div  v-if="!embeddedTableMode"   id="leftcellarea" class="vxe-table--cell-area" ref="fixedcellarea">
        <span class="vxe-table--cell-main-area"></span>
        <span class="vxe-table--cell-active-area"></span>
      </div>

      <div  v-if="!embeddedTableMode" id="rightcellarea" class="vxe-table--cell-area" ref="rightfixedcellarea">
        <span class="vxe-table--cell-main-area"></span>
        <span class="vxe-table--cell-active-area"></span>
      </div>
      <vxe-table
              stripe
              highlight-hover-row
              border
              resizable
              show-overflow
              class="sortable-row-demo"
              :data.sync="dataTest"
              @checkbox-all="selectAllEvent"
              @checkbox-change="checkboxChange"
              :cell-class-name="cellClassName"
              @cell-dblclick="dbcellClickEvent"
              @cell-click="tableCellClick"
              :max-height="MaxHeight"
              :keyboard-config="{ isArrow: true }"
              ref="pubTable"
              :footer-method="footerMethod"
              :scroll-x="{gt: -1}"
              size="mini"
              v-bind="gridOptions"
              @keydown="tableKeydown"
      >
        <!--:loading="loading"-->
        <!--:show-footer="statisticsStatus"-->
        <!--:footer-cell-class-name="footerCellClassName"-->
        <!--:footer-method="footerMethod"-->
        <!--@header-cell-dblclick="headerCellDbclick"-->
        <template v-slot:empty>
          <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
        </template>
        <template>
          <vxe-table-column type="checkbox" width="35" :fixed="fixedNum > 0 ? 'left' : ''"></vxe-table-column>
          <template  v-for="(item, index) in cloumnnames">
            <vxe-table-column :fixed="index < fixedNum ? 'left' : ''">
              <template v-slot:header>
                <a-tooltip placement="bottomLeft" v-if="statisticsStatus">
                  <span v-if="item.statisticsValue4OnePage == null || item.statisticsValue == null"></span>
                  <span v-else>
                    <a-tooltip>
                      <template slot="title">
                        {{item.statistics == 'Count' ? 'Count': 'Sum'}}
                      </template>
                      <span class="fontWeight6" :style="{color: item.statistics == 'Count' ? 'green' : 'blue'}" >{{item.statistics == 'Count' ? 'C:': 'S:'}}</span>
                      <span class="fontWeight6" :style="{color: item.statistics == 'Count' ? 'green' : 'blue'}">{{item.statisticsValue4OnePage}}</span>
                    </a-tooltip>
                  </span>
                </a-tooltip>
              </template>
              <vxe-table-column
                      show-header-overflow="ellipsis"
                      show-overflow="ellipsis"
                      :fixed="index < fixedNum ? 'left' : ''"
                      :min-width="item.proWidth == null ? '350' : item.proWidth"
                      :field="(item.uid).toString()"

              >
                <template v-slot:header="{ column }">
                  <a-row v-if="embeddedTableMode" class="sbxs">
                    <a-tooltip placement="topLeft">
                      <span v-cloak style="font-weight: 600">
                        {{ item.title }}
                        <a-tooltip v-if="isPrintQtyEditableColumn(item)" placement="top">
                          <template slot="title">
                            <span>Editable</span>
                          </template>
                          <a-icon type="edit" style="margin-left:6px;color:inherit;" />
                        </a-tooltip>
                      </span>
                    </a-tooltip>
                  </a-row>
                  <template v-else>
                  <!--功能-->
                  <a-row v-show="headerCellDbclickVis" class="sbxs">
                    <a-row>
                      <a-tooltip placement="topLeft">
                        <template slot="title">
                          <span v-cloak> {{item.description == null ? item.title : item.description}}</span>
                        </template>
                        <span v-cloak @click="headerCellDbclick" style="font-weight: 600">
                          {{ headerCellDbclickVis ? item.title : '' }}
                          <a-tooltip v-if="isPrintQtyEditableColumn(item)" placement="top">
                            <template slot="title">
                              <span>Editable</span>
                            </template>
                            <a-icon type="edit" style="margin-left:6px;color:inherit;" />
                          </a-tooltip>
                        </span>
                      </a-tooltip>

                      <a-icon type="caret-up" class="sortBtnClass" @click="locaSort(1, item)" v-if="upDownType"/>
                      <a-icon type="caret-down" class="sortBtnClass" @click="locaSort(-1, item)" v-else/>
                    </a-row>
                    <a-row style="display: flex;align-items: center;padding-bottom: 4px;width: 100%;" >
                      <a-date-picker showTime v-if="item.type == 'Datetime' || item.type == 'Date'" placeholder="Basic usage" style="width: 100%;" size="small" :defaultValue="item.serVal != undefined ? moment(item.serVal, 'YYYY-MM-DD') : null" format="YYYY-MM-DD" @change="dateTimeEvent" @openChange="openDateTimeEvent(item)"/>
                      <a-select mode="multiple" v-else-if="item.type == 'DROP'" style="width: 150px" size="small" @dropdownVisibleChange="($event) =>{$event ? tableTitleSelectData(item) : null }" @change="titleSlecChange" :defaultValue="item.serVal">
                        <a-select-option v-for="i in  titleSelectData" :value="i.key">{{i.value}}</a-select-option>
                      </a-select>
                      <a-input
                              v-else="item.type == 'String'"
                              type="text"
                              placeholder="Search"
                              style="width: 100%;border-right: none;height: 25px"
                              v-model="item.serVal"
                              @keyup.enter="searchTitleCont()"
                              size="small"
                      />
                      <a-icon type="search" @click="searchTitleCont()" style="font-size: 14px;" class="ml4"/>
                    </a-row>
                  </a-row>

                  <a-tooltip placement="topLeft" v-show="!headerCellDbclickVis">
                    <template slot="title">
                      <span v-cloak>{{item.description == null ? item.title : item.description}}</span>
                    </template>



                    <span v-cloak @click="headerCellDbclick" style="font-weight: 600" class="sbxs">
                      {{ headerCellDbclickVis ? '' : item.title }}
                      <a-tooltip v-if="isPrintQtyEditableColumn(item)" placement="top">
                        <template slot="title">
                          <span>Editable</span>
                        </template>
                        <a-icon type="edit" style="margin-left:6px;color:inherit;" />
                      </a-tooltip>
                    </span>
                  </a-tooltip>
                  </template>

                </template>
                <template v-slot="{ row }">
                  <a
                          v-if="isHttpHyperlink(row[item.label])"
                          href="#"
                          @click.stop.prevent="openHttpHyperlink(row[item.label].value)"
                  >{{ row[item.label].value }}</a>
                  <img
                          v-else-if="!hasHttpHyperlink(row[item.label]) && row[item.label].config.fieldType == 'Image'"
                          :src="row[item.label].value"
                          width="80"
                          height="30"
                  />
                  <div v-else>
                    <div v-if="!hasHttpHyperlink(row[item.label]) && isPrintQtyEditableColumn(item)" @click.stop>
                      <a-input-number
                        v-if="isNumericEditableField(row, item)"
                        size="small"
                        style="width: 100%;"
                        :precision="getNumberPrecision(row, item)"
                        :value="getCellValue(row, item)"
                        @change="(value) => onEditableCellChange(row, item, value)"
                      />
                      <a-date-picker
                        v-else-if="isDateEditableField(row, item)"
                        size="small"
                        style="width: 100%;"
                        :showTime="isDateTimeEditableField(row, item)"
                        :format="getEditableDateFormat(row, item)"
                        :value="getDateCellValue(row, item)"
                        @change="(date, dateString) => onEditableDateChange(row, item, dateString)"
                      />
                      <a-switch
                        v-else-if="isBooleanEditableField(row, item)"
                        size="small"
                        :checked="getBooleanCellValue(row, item)"
                        @change="(value) => onEditableBooleanChange(row, item, value)"
                      />
                      <a-select
                        v-else-if="isDropDownEditableField(row, item)"
                        size="small"
                        style="width: 100%;"
                        allowClear
                        :value="getSelectCellValue(row, item)"
                        @change="(value) => onEditableCellChange(row, item, value)"
                      >
                        <a-select-option
                          v-for="option in getEditableOptions(item)"
                          :key="option.value"
                          :value="option.value"
                        >{{ option.label }}</a-select-option>
                      </a-select>
                      <a-input
                        v-else
                        size="small"
                        :value="getCellValue(row, item)"
                        @change="(event) => onEditableCellChange(row, item, event.target.value)"
                      />
                    </div>

                    <a-tooltip  v-else placement="bottomLeft">
                      <template slot="title">
                        <span v-cloak>{{row[item.label].value}}</span>
                      </template>
                      <span
                              v-if="!hasHttpHyperlink(row[item.label]) && row[item.label].config.fieldType == 'POPUP'"
                              style="cursor:pointer;text-decoration:underline;"
                              @click="skuDetailCao(row[item.label],row)"
                      >{{ row[item.label].value }}</span>
                      <span
                              v-else
                              v-cloak>{{ row[item.label].value | textValFilter(item)}}</span>
                      <a-icon
                              style="font-size: 16px;float:right"
                              type="copy"
                              v-show="row!= undefined && row[item.label]!= undefined && row[item.label].config!= undefined && row[item.label].config.isShowCopy!= undefined&&(row[item.label].config.isShowCopy === 'true')"
                              v-if="row!= undefined && row[item.label]!= undefined && row[item.label].config!= undefined && row[item.label].config.isShowCopy!= undefined&&(row[item.label].config.isShowCopy === 'true' || row[item.label].config.isShowCopy === 'copySuccess')"
                              @click="copyText(row[item.label].value,row[item.label])"
                      />
                      <a-icon
                              style="font-size: 16px;float:right;color: green"
                              type="check"
                              v-if="row!= undefined && row[item.label]!= undefined && row[item.label].config!= undefined && row[item.label].config.isShowCopy!= undefined&&row[item.label].config.isShowCopy =='copySuccess'"
                      />
                    </a-tooltip>
                  </div>
                </template>
              </vxe-table-column>
            </vxe-table-column>
          </template>
        </template>
      </vxe-table>
      <a-button type="primary" size="small" icon="search" style="position: absolute;right: 0;top: 45%;" v-if="false"></a-button>
    </a-row>
    <!--排序-->
    <a-modal :title="$t('pubGicSet.Sort')" v-model="searchSortVis" width="50%">
      <template slot="footer">
        <a-button type="primary" @click="saveSort" size="small">{{ $t('pubGicSet.save') }}</a-button>
        <a-button type="primary" @click="getUpdateEvent" size="small">{{ $t('pubGicSet.Search') }}</a-button>
      </template>
      <div style="height: 55vh;">
        <vxe-table
          border
          height="auto"
          row-key
          class="sortable-row-demo"
          ref="sortTable"
          size="mini"
          :data.sync="editTableData"
          :edit-config="{ key: 'detaileUid', trigger: 'click', mode: 'row' }"
        >
          <template v-slot:empty>
            <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
          </template>
          <vxe-table-column type="checkbox" width="60"></vxe-table-column>
          <vxe-table-column
            show-header-overflow="ellipsis"
            show-overflow="ellipsis"
            field="fieldName"
            :title="$t('pubGicSet.FieldName')"
          ></vxe-table-column>
          <vxe-table-column
            show-header-overflow="ellipsis"
            show-overflow="ellipsis"
            field="orderBy"
            :title="$t('pubGicSet.OrderBy')"
            width="140"
            :edit-render="{ type: 'visible' }"
          >
            <template v-slot:edit="{ row, rowIndex }">
              <a-switch
                v-model="row.orderBy"
                checkedChildren="asc"
                unCheckedChildren="desc"
                size="small"
              ></a-switch>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </a-modal>

    <!--添加Advance search temalate name-->
    <a-modal :title="DrawerTitle" v-model="AdchNameVis">
      <template slot="footer">
        <a-button size="small" type="primary" @click="SaveTamplateName">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-form :form="AdchNameFrom">
        <a-form-item :label="$t('pubGicSet.Name')" v-bind="formItemLayout">
          <a-input
            v-decorator="[
              'template',
              { rules: [{ required: true, message: 'Please input your name' }] }
            ]"
            :placeholder="$t('pubGicSet.PleaseName')"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <!--Advance search-->
    <a-modal
      :title="DrawerTitle"
      v-model="AdvanceSearchVis"
      width="80%"
      @cancel="cancelAdvanceSearch"
    >
      <a-row type="flex" justify="start" style="margin-bottom: 10px;">
        <a-col style="margin-right: 5px;"><span>{{ $t('pubGicSet.SearchTemplate') }}: </span></a-col>
        <a-col>
          <a-select
                  size="small"
                  style="width: 240px"
                  :placeholder="$t('pubGicSet.AdvanceSearcheTemplate')"
                  v-model="targetAdvanceTml"
                  @change="changeTamplateAdvace"
          >
            <a-select-option
                    :value="item"
                    v-for="item in AdvanceTemplate"
            >{{ item }}</a-select-option
            >
          </a-select>
        </a-col>
        <a-col style="margin: 0 4px">
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>{{ $t('manual.New') }}</span>
            </template>
            <img class="sbxs" src="../../assets/img/ss-add.png"  @click="showAddTemplatName"  width="22" height="22">
          </a-tooltip>
        </a-col>
        <a-col>
          <a-popconfirm
              :title="$t('pubGicSet.AreyoudeleTask')"
              :okText="$t('pubGicSet.Yes')"
              :cancelText="$t('pubGicSet.No')"
              @confirm="deleteTemplatName"
          >
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span>{{ $t('pubGicSet.delete') }}</span>
              </template>
              <img class="sbxs" src="../../assets/img/ss-delete.png"  width="22" height="22">
            </a-tooltip>
          </a-popconfirm>
        </a-col>
        <a-col style="margin: 0 4px">
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>{{ $t('publicLang.Save') }}</span>
            </template>
            <img  @click="saveTemplateVers" class="sbxs" src="../../assets/img/ss-save.png"  width="20" height="20">
          </a-tooltip>
        </a-col>
      </a-row>
      <a-row>
        <and-or :options="options" :isFirst="isFirst" ref="andOr"></and-or>
      </a-row>
      <template slot="footer">
        <a-button type="primary" @click="getQueryFilter" size="small">{{ $t('pubGicSet.Search') }}</a-button>
      </template>
    </a-modal>
    <!--表格配置cell 点击去看详情-->
    <popup-single ref="popupSingleRef" :QueryUpdatas="QueryUpdatas"></popup-single>
    <!--column setting-->
    <a-modal v-model="columnSettingVis" title="Column Setting">
      <template slot="footer">
        <a-button size="small" type="danger" @click="cancelColumnSetting">Cancel</a-button>
        <a-button size="small" type="primary" @click="saveColumnSetting">Save</a-button>
      </template>
      <div style="height: 55vh;">
        <vxe-table
                border
                height="auto"
                class="sortable-row-demo"
                row-key
                size="mini"
                ref="columnSettingSortTable"
                :data.sync="columnSettingData"
                :edit-config="{ key: 'uid', trigger: 'click', mode: 'row' }"
        >
          <template v-slot:empty>
            <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
          </template>
          <vxe-table-column
                  show-header-overflow="ellipsis"
                  show-overflow="ellipsis"
                  field="fieldName"
                  title="Column Name"
          ></vxe-table-column>
          <vxe-table-column
                  show-header-overflow="ellipsis"
                  show-overflow="ellipsis"
                  field="displayable"
                  title="Displayable"
                  width="140"
                  :edit-render="{ type: 'visible' }"
          >
            <template v-slot:edit="{ row, rowIndex }">
              <a-switch v-model="row.displayable" size="small"></a-switch>
            </template>
          </vxe-table-column>
          <vxe-table-column
                  show-header-overflow="ellipsis"
                  show-overflow="ellipsis"
                  field="searchable"
                  title="Searchable"
                  width="140"
                  :edit-render="{ type: 'visible' }"
          >
            <template v-slot:edit="{ row, rowIndex }">
              <a-switch v-model="row.searchable" size="small"></a-switch>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </a-modal>
  </div>
</template>
<script>
import ajax from "../../api/ajax";
import api from "../../api/url";
import Sortable from "sortablejs";
import andOr from "../com/queryBuilder/components/AndOR.vue";
import { mapState } from "vuex";
import popupSingle from "../masterData/components/popupSingle.vue";
import moment from "moment";
import { trimRight } from 'xe-utils/methods';
import XEClipboard from 'xe-clipboard';
import { hasHttpHyperlink, isHttpHyperlink, openHttpHyperlink } from '../../utils/http-hyperlink';
export default {
  components: {
    andOr,
    popupSingle
  },
  props: {
    MaxHeight: {
      type: Number,
      default: function() {
        return 400;
      }
    },
      //            是否需要功能
    tableFuncionSearch: {
      type: Boolean,
      default: function() {
        return true;
      }
    },
      // 是否需要表头搜索
    functionSeting: {
      type: Boolean,
      default: function() {
        return true;
      }
    },
      // 固定列数
    fixedNum: {
      type: Number,
      default: function() {
        return 0;
      }
    },
      // 表头
    cols: {
      type: Array,
      default: function() {
        return [];
      }
    },
      // 表格数据
    tableData: {
      type: Array,
      default: function() {
        return [];
      }
    },
      // 表格uid
    setGmcuid: {
      type: Number,
      default: function() {
        return null;
      }
    },
    userReport:{
        type: Object,
        default: function() {
            return {};
        }
    },
    embeddedTableMode: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
  },
  data() {
    return {
      gridOptions:{
        //列配置 (使用列拖拽功能,必须配置useKey为true)
        "column-config":{resizable:true},
        //边框
        border:"full",
        //斑马纹
        stripe:true,
        //列信息
        //这里一定要指定true，否则row-config的height没用
        'show-overflow':true,
        //行配置,这里的行高一定需要指定
        "row-config":{isCurrent:true,height:30,isHover:true},
      },
      columnSettingVis: false,
      columnSettingData: [],
      cloumnnames: this.cols,


      upDownType: false,
      titleSelectData: [], // title status 下拉数据
      sliceStartTable: 0,
      sliceEndTable: 50,
      statisticsStatus: true,
      clientHeight: "",
      DrawerTitle: "", // Advance  Search title
      oldQueryFormStatus: {}, // 保存以前query filter
      options: {
        // query filter 下拉
        condition: [],
        fieldNameSel: [],
        status: []
      }, // advan 下拉数据
      visiblePopover: false, // 是显示最后set popover
      isFirst: true,
      AdvanceSearchVis: false,
      fixNum: "",
      searchSortVis: false,
      editTableData: [],
      selectRow: null,
      AdvanceTemplate: "",
      targetAdvanceTml: "",
      AdchNameVis: false,
      AdchNameFrom: this.$form.createForm(this),
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      },
      QueryUpdatas: {},
      headerCellDbclickVis: false,
      sortKey: "",
      sortType: "",
      oldTable: [],
      targetSelectItem: '',
      targetDateTimeItem: {},
      geExtHeaderUid: '', // columnSetting uid
      switchCopySuccess:false,
      isSelecting: false, // 是否正在进行选择操作
      selectionStart:{rowIndex:-1,cellIndex:-1}, // 选择操作起始单元格位置
      selectionEnd:{rowIndex:-1,cellIndex:-1}, // 选择操作结束单元格位置
    };
  },
  created() {
      this.fixNum = this.fixedNum
  },
  beforeDestroy() {
    if (this.sortable) {
      this.sortable.destroy();
    }
  },
  watch: {
      cols(newValue,oldValue){
        for(let i in this.newValue){
            if(this.cols[i].statisticsValue4OnePage != null ){
               this.statisticsStatus = true
               break;
            }
        }
       if( ! this.statisticsStatus ){
            this.statisticsStatus = false
        }
       this.cloumnnames = newValue
      }
  },
  mounted() {
    if (!this.embeddedTableMode) {
      this.addListener();
    }
  },
  computed: {
    ...mapState(["lang"]),
    ...mapState(["systemParam"]),
    dataTest() {
      let that = this;
      let tableData = this.tableData;
      let sortKey = this.sortKey;
        if (sortKey) {
            return tableData.sort(that.compare(sortKey));
         }else{
            return tableData;
      }
    }
  },
  filters: {
    textValFilter: function (val,params) {
        if(val == null){
            return ''
        }else{
            if(params.type == "Datetime"){
                if(params.dataFormat != null){
                    let t = moment(val).format(params.dataFormat);
                    return t
                }else{
                   return val
                }
            }else if(params.type == "Decimal"){
                if(params.dataFormat != null){
                    let t = this.pub_decimaltoFixed(val, params.dataFormat)
                    return t
                }else{
                    return val
                }
            }else{
                return val
            }
        }
    },
  },
  methods: {
      hasHttpHyperlink,
      isHttpHyperlink,
      openHttpHyperlink(value) {
        openHttpHyperlink(value).catch(() => {
          this.$customMessage.warning(this.$t('publicLang.DownloadFailed'), 3);
        });
      },
    isPrintQtyEditableColumn(item) {
      return this.embeddedTableMode === true && item != null && String(item.editable).trim() === '1';
    },
    getEditableFieldType(row, item) {
      const cell = row && item && row[item.label];
      const fieldType = cell && cell.config && cell.config.fieldType != null
        ? cell.config.fieldType
        : item && item.type;
      return fieldType == null ? 'STRING' : String(fieldType).trim().toUpperCase();
    },
    isNumericEditableField(row, item) {
      const fieldType = this.getEditableFieldType(row, item);
      return /^\d+$/.test(fieldType) || [
        'INTEGER', 'INT', 'BIGINT', 'SMALLINT', 'DECIMAL',
        'NUMERIC', 'NUMBER', 'FLOAT', 'DOUBLE'
      ].includes(fieldType);
    },
    isDateEditableField(row, item) {
      const fieldType = this.getEditableFieldType(row, item);
      return fieldType === 'DATE' || fieldType === 'DATETIME' || fieldType === 'TIMESTAMP';
    },
    isDateTimeEditableField(row, item) {
      const fieldType = this.getEditableFieldType(row, item);
      return fieldType === 'DATETIME' || fieldType === 'TIMESTAMP';
    },
    isBooleanEditableField(row, item) {
      const fieldType = this.getEditableFieldType(row, item);
      return fieldType === 'BOOLEAN' || fieldType === 'BOOL';
    },
    isDropDownEditableField(row, item) {
      const fieldType = this.getEditableFieldType(row, item);
      return fieldType === 'DROP' || fieldType === 'SELECT';
    },
    getNumberPrecision(row, item) {
      const fieldType = this.getEditableFieldType(row, item);
      if (/^\d+$/.test(fieldType)) return Number(fieldType);
      return ['INTEGER', 'INT', 'BIGINT', 'SMALLINT'].includes(fieldType) ? 0 : undefined;
    },
    getEditableDateFormat(row, item) {
      return this.isDateTimeEditableField(row, item) ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
    },
    getCellValue(row, item) {
      const cell = row && item && row[item.label];
      return cell && cell.value != null ? cell.value : undefined;
    },
    getDateCellValue(row, item) {
      const value = this.getCellValue(row, item);
      if (value == null || value === '') return null;
      const date = moment(value);
      return date.isValid() ? date : null;
    },
    getBooleanCellValue(row, item) {
      const value = this.getCellValue(row, item);
      return value === true || value === 1 || String(value).toUpperCase() === 'Y' || String(value) === '1';
    },
    getEditableOptions(item) {
      const options = item && item.options;
      if (options == null || typeof options !== 'object') return [];
      return Object.keys(options).map(value => ({
        value,
        label: options[value] == null ? value : options[value]
      }));
    },
    getSelectCellValue(row, item) {
      const cell = row && item && row[item.label];
      const value = cell && cell.code != null ? cell.code : this.getCellValue(row, item);
      return value == null ? undefined : String(value);
    },
    onEditableBooleanChange(row, item, checked) {
      if (!row || !item || !row[item.label]) return;
      const cell = row[item.label];
      const originalCode = cell.code;
      let nextCode = checked;
      if (typeof originalCode === 'number') {
        nextCode = checked ? 1 : 0;
      } else if (typeof originalCode === 'string') {
        const normalizedCode = originalCode.trim().toUpperCase();
        if (normalizedCode === '1' || normalizedCode === '0') {
          nextCode = checked ? '1' : '0';
        } else if (normalizedCode === 'Y' || normalizedCode === 'N') {
          nextCode = checked ? 'Y' : 'N';
        } else if (normalizedCode === 'TRUE' || normalizedCode === 'FALSE') {
          nextCode = checked ? 'true' : 'false';
        }
      }
      cell.value = checked;
      cell.code = nextCode;
    },
    onEditableCellChange(row, item, value) {
      if (!row || !item || !row[item.label]) return;
      const nextValue = value === undefined ? null : value;
      row[item.label].value = nextValue;
      row[item.label].code = nextValue;
    },
    onEditableDateChange(row, item, value) {
      this.onEditableCellChange(row, item, value || null);
    },
      columnSetting(){
        ajax.get(api.GENERICEXTGENERICCOLUMN,{gmcUid: this.setGmcuid}).then(res=>{
            if(res.code == 200){
                this.geExtHeaderUid = res.data.uid
                ajax.get(api.GENERICEXTGENERICPAGEPROPERTY,{geExtHeaderUid: res.data.uid}).then(res=>{
                    this.columnSettingData = res.data.geExtDetailDtos
                    if(this.columnSettingData.length > 0){
                        for(let i in this.columnSettingData){
                            this.columnSettingData[i].displayable = this.columnSettingData[i].displayable == 1 ? true : false
                            this.columnSettingData[i].searchable = this.columnSettingData[i].searchable == 1 ? true : false
                        }
                    }
                    this.columnSettingVis = true
                    this.$nextTick(() => {
                        let sortTable = this.$refs.columnSettingSortTable
                        let sortable = Sortable.create(sortTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'), {
                            onEnd: ({ newIndex, oldIndex }) => {
                                let currRow = this.columnSettingData.splice(oldIndex, 1)[0];
                                this.columnSettingData.splice(newIndex, 0, currRow);
                            }
                        });
                    });
                })
            }
        })
      },
//      cancel column Setting
      cancelColumnSetting(){
          ajax.get(api.GNERICEXTGENERICCANCEL,{geExtHeaderUid: this.geExtHeaderUid}).then(res=>{
              if(res.code == 200){
                  this.$message.success(res.msg)
                  this.columnSettingVis = false
                  this.$parent.init()
              }
          })
      },
//      保存columnSetting
      saveColumnSetting(){
          let data = JSON.parse(JSON.stringify(this.columnSettingData))
          for(let i in data){
              data[i].displayable = data[i].displayable  ? '1' : '0'
              data[i].searchable = data[i].searchable ? '1' : '0'
          }
          ajax.post(api.GENERICEXTGENERICPAGEPROPERTY,{geExtDetailDtos: data}).then(res=>{
              if(res.code == 200){
                  this.$message.success(res.msg)
                  this.columnSettingVis = false
                  this.$parent.init()
              }
          })
      },

//      保留小学
    pub_decimaltoFixed(params,num) {
        let newpar = parseFloat(params);
        let reg = /^[0-9]+.?[0-9]*$/;
        if(reg.test(newpar)){
            let newNum = newpar.toFixed(num);
            return newNum
        }else{
            return params
        }
    },
//      重新刷新表格
    newData(){
        this.$refs.pubTable.loadData(this.tableData)
    },
    dateTimeEvent(val){
        for(let i in this.cols){
            if(this.cols[i].label == this.targetDateTimeItem.label){
                if(val == null){
                    this.cols[i].serVal = ''
                }else{
                    this.cols[i].serVal = val._d
                }
            }
        }
    },
    openDateTimeEvent(item){
        this.targetDateTimeItem = item
    },
    moment,
    titleSlecChange(val){
        for(let i in this.cols){
            if(this.cols[i].label == this.targetSelectItem.label){
                this.cols[i].serVal = val
            }
        }
    },
    tableTitleSelectData(item){
        let ppArr = []
        let params = {
            language: this.lang,
            gmcUid: item.pattern.gmcUid,
            params: ppArr
        };

    if(item.codeGroup != undefined && item.codeGroup != null   && item.codeGroup.trim().length > 0 ){
                  params.gmcUid = this.setGmcuid
                  params.codeGroup = item.codeGroup
     }

        ajax.post(api.GETSELECTARRAY, params).then(res => {
            this.targetSelectItem = item
            this.titleSelectData = res.data
        });
    },
//      底部合集
    footerMethod({ columns, data }) {
          let that = this;
          let a = false
          for(let i in this.cols){
              if(this.cols[i].statisticsValue != null ){
                  a = true
              }
          }
          if(a){
              this.statisticsStatus = true
          }else{
              this.statisticsStatus = false
          }
          return [
              columns.map((column, columnIndex) => {
                  if(columnIndex == 0){
                      return ''
                  }else{
                      let arr = []
                      let val = 0
                      let tt = ''
                      let dataUid = this.cols[columnIndex-1].label
                      for(let i in data){
                          arr.push(data[i][dataUid].value)
                      }
                      if(this.cols[columnIndex-1].statistics == 'SUM'){
                          for (var i=arr.length-1; i>=0; i--) {
                              val += arr[i] - 0;
                          }
                          tt = val + '/'+ this.cols[columnIndex-1].statisticsValue
                      } else if (this.cols[columnIndex-1].statistics == 'Count'){
                          val =  Array.from(new Set(arr)).length
                          tt =val + '/'+ this.cols[columnIndex-1].statisticsValue
                      } else{
                          tt = ''
                      }
                      return tt
                  }
              })
          ];
      },
//      本地排序
    compare(propertyName) {
      return (object1, object2) => {
        let a =
          object1[propertyName].value == null
            ? "9"
            : object1[propertyName].value;
        let b =
          object2[propertyName].value == null
            ? "9"
            : object2[propertyName].value;
        if (a < b) {
          return this.sortType * 1;
        } else if (a > b) {
          return this.sortType * -1;
        }
        return 0;
      };
    },
    //            本地排序
    locaSort(type, item) {
      if (this.embeddedTableMode) return;
      this.upDownType = !this.upDownType
      this.sortKey = item.label;
      this.sortType = type;
    },
//      头部双击
    headerCellDbclick() {
      if (this.embeddedTableMode) return;
        this.$refs.pubTable.refreshColumn()
        this.headerCellDbclickVis = !this.headerCellDbclickVis;
    },
    //            显示新增加ansearch tamplate nam
    showAddTemplatName() {
      this.AdchNameVis = true;
    },
    saveTemplateVers(){
        if(this.targetAdvanceTml != ''){
            let params = this.$refs.andOr.queryFormStatus();
            params.template = this.targetAdvanceTml
            params.gmcUid = this.setGmcuid;

            if(this.userReport.ugcUid != null){
                params.ugcUid = this.userReport.ugcUid
                ajax.post(api.GENERICUDRTEMPLATEREAL, params).then(res=>{
                    if (res.code == 200) {
                        this.$message.success(this.$t('pubGicSet.SaveSuccess'))
                    }
                })
            }else{
                ajax.post(api.QUERYFILTER, params).then(res => {
                    if (res.code == 200) {
                        this.$message.success(this.$t('pubGicSet.SaveSuccess'))
                    }
                })
            }
        }else{
            this.$customMessage.warning(this.$t('pubGicSet.PleaseTamplateNameFirst'));
        }
      },
//      弹窗添加template name
    SaveTamplateName() {
      this.AdchNameFrom.validateFields((error, values) => {
        if (!error) {
          let params = this.$refs.andOr.queryFormStatus();
          params.template = values.template;
          params.gmcUid = this.setGmcuid;


          if(this.userReport.ugcUid != null){
              params.ugcUid = this.userReport.ugcUid
              ajax.post(api.GENERICUDRTEMPLATEREAL, params).then(res=>{
                  if (res.code == 200) {
                      this.init();
                      this.AdchNameVis = false;
                      this.AdchNameFrom.resetFields();
                  }
              })
          }else{
              ajax.post(api.QUERYFILTER, params).then(res => {
                  if (res.code == 200) {
                      this.init();
                      this.AdchNameVis = false;
                      this.AdchNameFrom.resetFields();
                  }
              });
          }
        }
      });
    },
    //            删除tamplate Name
    deleteTemplatName() {
      let params = {
        gmcUid: this.setGmcuid,
        templateName: this.targetAdvanceTml
      };
      ajax.post(api.DELETETEMPLATE, params).then(res => {
        if (res.code == 200) {
          this.init();
          this.AdvanceSearch();
        }
      });
    },
    changeTamplateAdvace(val) {
      let params = {
        gmcUid: this.setGmcuid,
        template: val
      };
        if(this.userReport.ugcUid != null){
            params.ugcUid = this.userReport.ugcUid
        }
      ajax.get(api.QUERYFILTER, params).then(res => {
        let queryObj = res.data;
          this.$refs.andOr.fillFormStatus(queryObj);
      });
    },
    init() {
        let tmlParams = {
            gmcUid: this.setGmcuid,
        }
        if(this.userReport.ugcUid != null){
            tmlParams.ugcUid = this.userReport.ugcUid
        }
      ajax.get(api.ADVANCETEMPLATE, tmlParams).then(res => {
        this.AdvanceTemplate = res.data;
        this.targetAdvanceTml = this.AdvanceTemplate[0];
      });
    },
    AdvanceSearch(type) {
      let menuActive = sessionStorage.getItem("menuActive");
      let menuArr = JSON.parse(sessionStorage.getItem("menu"));
      if (menuArr == null) {
        this.DrawerTitle = "Home";
      } else {
        menuArr.forEach((v, i) => {
          if (v.key == menuActive) {
            this.DrawerTitle = v.funcName;
          }
        });
      }
//      获取模板
        let tmlParams = {
            gmcUid: this.setGmcuid,
        }
        if(this.$route.path == "/userReport"){
            tmlParams.ugcUid = this.userReport.ugcUid == null ? 0 : this.userReport.ugcUid
            this.DrawerTitle = this.userReport.genericName
        }
        ajax.get(api.ADVANCETEMPLATE,tmlParams).then(res => {
           this.AdvanceTemplate = res.data;
          this.targetAdvanceTml = this.AdvanceTemplate[0];
          });
          let params = {
                gmcUid: this.setGmcuid
            };
          ajax.get(api.GETSQLDROPDATA).then(res => {
            this.options.condition = res.data.condition;
          });


        if(this.$route.path == "/userReport"){
            let paramsUgc = {
                gmcUid: this.setGmcuid,
                ugcUid: this.userReport.ugcUid == null ? 0 : this.userReport.ugcUid
            }
            ajax.get(api.GENERICUDRDROPDOWNFIELNAME,paramsUgc).then(res=>{
                this.options.fieldNameSel = res.data;
            })
        }else{
            ajax.post(api.GETFIELDNAMEDROPDATA, params).then(res => {
                this.options.fieldNameSel = res.data;
            });
        }

      ajax.get(api.GEBERICMODULESTATUS, { gmcUid: this.setGmcuid }).then(res => {
          this.options.status = res.data;
      });
      this.AdvanceSearchVis = true;

      if(this.$route.path == "/userReport"){
          let queryParams = {
              gmcUid: this.setGmcuid,
              ugcUid: this.userReport.ugcUid == null ? 0 : this.userReport.ugcUid
          };
          ajax.get(api.GENERICYDRTMLDEFAULT,queryParams).then(res=>{
              if(res.code == 200){
                let queryObj = res.data;
                if(queryObj.rules == null){
                    queryObj = undefined
                }else{
                    queryObj = res.data.rules[0]
                }
                this.$nextTick(()=>{
                    this.$refs.andOr.fillFormStatus(queryObj);
                })
            }else{
                this.$customMessage.error(res.msg);
                this.AdvanceSearchVis = false
                return
            }

        })
      }else{
          let queryParams = {
              gmcUid: this.setGmcuid
          };
          ajax.get(api.QUERYFILTER, queryParams).then(res => {
              let queryObj = res.data;
              this.$nextTick(()=>{
                  this.$refs.andOr.fillFormStatus(queryObj);
              })
          });
      }
      this.visiblePopover = false;
    },
    //            提交
    getQueryFilter(){
        let params = {
        query: this.$refs.andOr.queryFormStatus(),
        tml: this.targetAdvanceTml
      };
      this.$emit("clearConditionQuery");
      this.$emit("renderQueryVal", params);
      this.AdvanceSearchVis = false;
    },
    //            关闭也需要保存queryFilter data
    cancelAdvanceSearch() {
      this.oldQueryFormStatus = this.$refs.andOr.queryFormStatus();
    },
    handleChange(value) {
      this.fixNum = value;
      this.$emit("rederSub", parseInt(this.fixNum));
    },
    //            title Search
    searchTitleCont() {
      if (this.embeddedTableMode) return;
      this.$emit("clearConditionQuery");
      this.$emit("renderSearchVal",  this.cloumnnames);
    },
    //            推拽
    rowDrop() {
      this.$nextTick(() => {
          let sortTable = this.$refs.sortTable
          let sortable = Sortable.create(sortTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'), {
          onEnd: ({ newIndex, oldIndex }) => {
            let currRow = this.editTableData.splice(oldIndex, 1)[0];
            this.editTableData.splice(newIndex, 0, currRow);
          }
        });
      });
    },
    //            双击当前行变色
    cellClassName({ row }) {
      if (row === this.selectRow) {
        return "col-orange";
      }
    },
    //            双击当前行变色
    dbcellClickEvent({ row }) {
      this.$emit("selectRowData", row);
      this.selectRow = row;
    },
    //            checkbox选择
    checkboxChange(value) {
      this.$emit("checkBoxSelectData", value.selection);
    },
    selectAllEvent(value) {
      this.$emit("checkBoxSelectData", value.selection);
    },
    //            表头最后一个sort
    searchSort() {
      //                提示拖动
      this.$message.success(this.$t('publicLang.DraglistSort'));
      let gmcUid = this.setGmcuid;
      this.searchSortVis = true;
      this.visiblePopover = false;
      ajax.get(api.SEARCHSORT, { gmcUid: gmcUid }).then(res => {
        this.editTableData = res.data;
        let checkboArr = [];
        this.editTableData.forEach((v, i) => {
          v.orderBy = v.orderBy == 0 ? false : true;
          if (v.isSort == "1") {
            checkboArr.push(this.editTableData[i]);
          }
          this.$refs.sortTable.setCheckboxRow(checkboArr, true);
        });
        this.rowDrop();
      });
    },
    saveSort(){
       let updateRecords = this.$refs.sortTable.getCheckboxRecords(); // 当数组为 [] ,即清除当前账号的数据
       let params = {
         gmcUid: this.setGmcuid,
         userSortDtos: updateRecords
       }
       ajax.post(api.SEARCHSORT, params).then(res => { 
             if (res.code == 200) {
                  this.$message.success(res.msg);
               } else {
                  this.$customMessage.warning(res.msg,3);
               }
        });
    },
    getUpdateEvent() {
      let updateRecords = this.$refs.sortTable.getCheckboxRecords();
      for (let ii in updateRecords) {
        updateRecords[ii].isSort = "1";
      }
      this.$emit("renderSortVal", updateRecords);
      this.searchSortVis = false;
    },
    skuDetailCao(column,row) {
      console.info(column)
      if(column.hyperlink != null && column.hyperlink != ''){
        let  uid = row.uid
        if (column.hyperlink  == 'info'){
          // if(column.code == 'Queuing' ){
          //
          // }


          this.$emit('showNotification',uid);
        }
        return;
      }

      let params = {
        gmcUid: column.config.fieldPattern.gmcUid,
        language: this.lang,
        pop: {
          schemaUid: column.config.schemaUid,
          value: column.value
        }
      };
      this.$nextTick(() => {
        this.$refs.popupSingleRef.openPopup();
      });
      ajax.post(api.POPUP, params).then(res => {
        this.QueryUpdatas = res;
      });
    },
    copyText(text,row) {
      row.config.isShowCopy="copySuccess";
      let input = document.createElement('input'); // 构建临时input
      input.value = text;  // 要复制的内容
      document.body.appendChild(input);  // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand('copy') // 选择实例内容
      document.body.removeChild(input); // 删除临时实例
      setTimeout(() => {
        row.config.isShowCopy="true";
      }, 2000);
    },
	 //表格单元格点击事件
      tableCellClick(e){
        if (this.embeddedTableMode) return;
        let {row,column}=e;
        if(!this.isSelecting){
          this.closeAreaBox();
          this.selectionStart = this.getCellPosition(e.$event.target);
          this.selectionEnd =this.selectionStart;
          //设置样式
          this.setselectedCellArea();
        }
      },
      //返回table的ref名称
      getTablexGrid(){
        return this.$refs.pubTable;
      },
      //添加事件
      addListener(){
        //添加多选列
        this.$nextTick(()=>{
          let tbody=this.getTablexGrid().$el.querySelector(".vxe-table--main-wrapper table tbody");
          if(tbody){
            tbody.addEventListener("mousedown",this.tbodymousedown);
            tbody.addEventListener("mouseup",this.tbodymouseup);
            tbody.addEventListener("mousemove",this.tbodymousemove);
            tbody.addEventListener("paste",this.tbodykeydown);
          }
          let bodyWrapper=this.getTablexGrid().$el.querySelector(".vxe-table--main-wrapper .vxe-table--body-wrapper");
          if(bodyWrapper){
            //注意这里的ref名称，这里是非fixed区域的框的名称
            bodyWrapper.appendChild(this.$refs.cellarea);
          }

          setTimeout(()=>{
            let leftfixedtbody=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-left-wrapper table tbody");
            if(leftfixedtbody){
              leftfixedtbody.addEventListener("mousedown",this.tbodymousedown);
              leftfixedtbody.addEventListener("mouseup",this.tbodymouseup);
              leftfixedtbody.addEventListener("mousemove",this.tbodymousemove);
              leftfixedtbody.addEventListener("paste",this.tbodykeydown);
            }

            let leftfixedBodyWrapper=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-left-wrapper .vxe-table--body-wrapper");
            if(leftfixedBodyWrapper){
              //注意这里的ref名称，这里是fixed区域的框的名称
              leftfixedBodyWrapper.appendChild(this.$refs.fixedcellarea);
            }
          })


          setTimeout(()=>{
            let rightfixedtbody=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-right-wrapper table tbody");

            if(rightfixedtbody){
              rightfixedtbody.addEventListener("mousedown",this.tbodymousedown);
              rightfixedtbody.addEventListener("mouseup",this.tbodymouseup);
              rightfixedtbody.addEventListener("mousemove",this.tbodymousemove);
              rightfixedtbody.addEventListener("paste",this.tbodykeydown);
            }

            let rightfixedBodyWrapper=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-right-wrapper .vxe-table--body-wrapper");
            if(rightfixedBodyWrapper){
              //注意这里的ref名称，这里是fixed区域的框的名称
              rightfixedBodyWrapper.appendChild(this.$refs.rightfixedcellarea);
            }
          })
        })
      },
      //鼠标按下事件
      tbodymousedown(event){
        //左键
        if(event.button === 0){
          this.closeAreaBox();
          // 记录选择操作起始位置,
          this.selectionStart = this.getCellPosition(event.target);
          this.tempselectionStart = this.getCellPosition(event.target);
          this.isSelecting = true;
        }
      },
      //鼠标移动事件
      tbodymousemove(event){
        //左键
        if(event.button === 0 && event.buttons == 1){
          if (!this.isSelecting) return;
          var x = event.clientX;
          // 记录选择操作结束位置
          this.selectionEnd = this.getCellPosition(event.target);
          //设置样式
          this.setselectedCellArea();
          //持续向右滚动
          var x = event.clientX;
          var table=this.getTablexGrid().$el.querySelector(".vxe-table--body-wrapper table");
          if(table){
            let tableRect=table.parentElement.getBoundingClientRect();
            if (x > tableRect.right - 20){
              table.parentElement.scrollLeft+=20;
            }
          }
        }
      },
      //鼠标按键结束事件
      tbodymouseup(event) {
        //左键
        if(event.button === 0){
          this.isSelecting = false;
        }
      },
      // 获取单元格位置
      getCellPosition(cell) {
        try{
          while(cell.tagName !== 'TD'){
            cell = cell.parentElement;
          }
          const rowIndex2 = cell.parentElement.rowIndex;
          const cellIndex2 = cell.cellIndex;
          const test = cell.getAttribute("data-colid");
          let visibleColumn=this.getTablexGrid().getTableColumn()["visibleColumn"];
          const cellIndex = visibleColumn.findIndex((col)=>{
            return col.id==cell.getAttribute("data-colid");
          })
          let visibleData=this.getTablexGrid().getTableData()["visibleData"];
          const rowIndex =visibleData.findIndex((row)=>{
            return row._XID==cell.parentElement.getAttribute("data-rowid");
          })
          return { rowIndex, cellIndex };
        }catch(e){
          return { rowIndex:-1,cellIndex:-1};
        }
      },
      //设置框打开
      setselectedCellArea(){
        try{
          let startRowIndex=this.selectionStart["rowIndex"];
          let endRowIndex=this.selectionEnd["rowIndex"];
          let startColumnIndex=this.selectionStart["cellIndex"];
          let endColumnIndex=this.selectionEnd["cellIndex"];
          let {width,height,left,top,leftFixedWidth,rightFixedWidth,mainWidth,rightFixedLeft}=this.getAreaBoxPostion();
          // .vxe-table--fixed-wrapper .vxe-table--body-wrapper
          // .vxe-table--main-wrapper .vxe-table--body-wrapper
          var activeElement=this.getTablexGrid().$el.querySelector(".vxe-table--main-wrapper .vxe-table--body-wrapper .vxe-table--cell-active-area");
          var mainElement=this.getTablexGrid().$el.querySelector(".vxe-table--main-wrapper .vxe-table--body-wrapper .vxe-table--cell-main-area");
          var leftfixedActiveElement=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-left-wrapper .vxe-table--body-wrapper .vxe-table--cell-active-area");
          var leftfixedMainElement=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-left-wrapper .vxe-table--body-wrapper .vxe-table--cell-main-area");
          var rightfixedActiveElement=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-right-wrapper .vxe-table--body-wrapper .vxe-table--cell-active-area");
          var rightfixedMainElement=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-right-wrapper .vxe-table--body-wrapper .vxe-table--cell-main-area");
          //获取固定列宽度fixed--hidden
          var fixedWidth=0;
          let flexDiv=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-left-wrapper");
          if(flexDiv){
            fixedWidth=flexDiv.offsetWidth;
          }
          var elements=[activeElement,mainElement,leftfixedActiveElement,leftfixedMainElement];
          elements.forEach((element)=>{
            if(element){
              element.style.width=`${width}px`;
              element.style.height=`${height}px`;
              element.style.top=`${top}px`;
              element.style.left=`${left}px`;
              element.style.display="block";
            }
          })
          //如果选择的索引位置大于等于右侧固定的位置
          //获取右侧固定的索引位置
          let rightFixedIndex=this.getrightFixedIndex();
          if(rightFixedIndex>-1&&endColumnIndex>=rightFixedIndex){
            elements=[rightfixedActiveElement,rightfixedMainElement];
            elements.forEach((element)=>{
              if(element){
                element.style.width=`${rightFixedWidth}px`;
                element.style.height=`${height}px`;
                element.style.top=`${top}px`;
                element.style.left=`${rightFixedLeft}px`;
                element.style.display="block";
              }
            })
          }
          this.openAreaBox();
          this.selectionStart={"cellIndex":startColumnIndex,"rowIndex":startRowIndex};
          this.selectionEnd={"cellIndex":endColumnIndex,"rowIndex":endRowIndex};
        }catch(e){

        }
      },
      getrightFixedIndex(){
        let visibleColumn=this.getTablexGrid().getTableColumn()["visibleColumn"];
        return visibleColumn.findIndex((col)=>{
          return col.fixed=="right";
        })
      },
      //根据开始位置和结束位置的索引计算框的width,height,left,top
      getAreaBoxPostion(){
        let startRowIndex=this.selectionStart["rowIndex"];
        let endRowIndex=this.selectionEnd["rowIndex"];
        let startColumnIndex=this.selectionStart["cellIndex"];
        let endColumnIndex=this.selectionEnd["cellIndex"];
        let visibleColumn=this.getTablexGrid().getTableColumn()["visibleColumn"];
        let visibleData=this.getTablexGrid().getTableData()["visibleData"];
        if(startColumnIndex<0||endColumnIndex<0||startRowIndex<0||endRowIndex<0)return;
        var maxColumnIndex=visibleColumn.length-1;
        var maxRowIndex=visibleData.length-1;
        if(endColumnIndex>maxColumnIndex){
          endColumnIndex=maxColumnIndex;
        }
        if(endRowIndex>maxRowIndex){
          endRowIndex=maxRowIndex;
        }
        // height width left top display
        // cellarea
        let width=0,height=0,left=0,top=0,leftFixedWidth=0,rightFixedWidth=0,mainWidth=0,rightFixedLeft=0,leftFixedLeft=0;
        let fixedwidth=0,fixedheight=0,fixedleft=0,fixedtop=0;

        for (let index = 0; index < visibleColumn.length; index++) {
          let col = visibleColumn[index]
          let colid = col.id;
          let columnWidthTemp = this.getTablexGrid().getColumnById(colid).renderWidth;
          if(columnWidthTemp == undefined) {
            columnWidthTemp = 0;
          }
          if(index<startColumnIndex){
            left+=columnWidthTemp;
            if(col.fixed=="left"){
              leftFixedLeft+=columnWidthTemp;
            }else if(col.fixed=="right"){
              rightFixedLeft+=columnWidthTemp;
            }
          }
          if(index<=endColumnIndex&&startColumnIndex<=index){
            width+=columnWidthTemp;
            if(col.fixed=="left"){
              leftFixedWidth+=columnWidthTemp;
            }else if(col.fixed=="right"){
              rightFixedWidth+=columnWidthTemp;
            }else{
              mainWidth+=columnWidthTemp;
            }
          }
        }

        height=(endRowIndex-startRowIndex+1)*this.gridOptions["row-config"]["height"];
        if(height<=0||width<=0){
          this.destroyAreaBox();
          return;
        }
        top=startRowIndex*this.gridOptions["row-config"]["height"];
        return {width,height,left,top,leftFixedWidth,rightFixedWidth,mainWidth,rightFixedLeft,leftFixedLeft};
      },
      //显示范围框
      openAreaBox(){
        var element=this.getTablexGrid().$el.querySelector(".vxe-table--main-wrapper .vxe-table--body-wrapper .vxe-table--cell-area");
        if(element){
          element.style.display="block";
        }
        element=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-left-wrapper .vxe-table--body-wrapper .vxe-table--cell-area");
        if(element){
          element.style.display="block";
        }
        let rightFixedIndex=this.getrightFixedIndex();
        if(rightFixedIndex>-1&&this.selectionEnd["cellIndex"]>=rightFixedIndex){
          element=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-right-wrapper .vxe-table--body-wrapper .vxe-table--cell-area");
          if(element){
            element.style.display="block";
          }
        }
      },
      //关闭范围框
      closeAreaBox(){
        var element=this.getTablexGrid().$el.querySelector(".vxe-table--main-wrapper .vxe-table--body-wrapper .vxe-table--cell-area");
        if(element){
          element.style.display="none";
        }
        element=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-left-wrapper .vxe-table--body-wrapper .vxe-table--cell-area");
        if(element){
          element.style.display="none";
        }
        element=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-right-wrapper .vxe-table--body-wrapper .vxe-table--cell-area");
        if(element){
          element.style.display="none";
        }
      },
      //销毁范围框
      destroyAreaBox(){
        this.selectionStart={"rowIndex":-1,"cellIndex":-1};
        this.selectionEnd={"rowIndex":-1,"cellIndex":-1};
        this.closeAreaBox();
      },


      tableKeydown({$event}){
        this.tbodykeydown($event);
      },
      tbodykeydown(event){
        let tablexgrid=this.getTablexGrid();
        let tableColumn=this.getTablexGrid().getTableColumn()["visibleColumn"];
        let tableData=this.getTablexGrid().getTableData()["visibleData"];
        let startRowIndex=this.selectionStart["rowIndex"];
        let endRowIndex=this.selectionEnd["rowIndex"];
        let startColumnIndex=this.selectionStart["cellIndex"];
        let endColumnIndex=this.selectionEnd["cellIndex"];
        var maxColumnIndex=tableColumn.length-1;
        var maxRowIndex=tableData.length-1;
        var minColumnIndex=0;
        var minRowIndex=0;

        if (event.ctrlKey && event.keyCode === 67) {
          //ctrl+c 复制
          this.contextMenuClickEvent({menu:{code:"cellCopy"}});
          event.preventDefault();
        }
      },
      contextMenuClickEvent({menu,row,column,rowIndex,columnIndex,$event}){
        let startRowIndex=this.selectionStart["rowIndex"];
        let endRowIndex=this.selectionEnd["rowIndex"];
        let startColumnIndex=this.selectionStart["cellIndex"];
        let endColumnIndex=this.selectionEnd["cellIndex"];
        let visibleColumnData = this.getTablexGrid().getTableColumn()["visibleColumn"];
        var tableData=this.getTablexGrid().getTableData()["visibleData"];
        switch(menu.code){
                //复制
          case "cellCopy":
            let enterStr="\r\n";
            let spaceStr="\t";
            let data=[];
            for(var i=startRowIndex;i<=endRowIndex;i++){
              let value=[];
              for(var j=startColumnIndex;j<=endColumnIndex;j++){
                value.push(tableData[i][visibleColumnData[j].property].value);
              }
              data.push(value);
            }
            let finalStr=data.map((value)=>{
              return value.join(spaceStr);
            }).join(enterStr);
            this.copyValue(finalStr);
            break;

        }
      },

      //复制的工具方法
      copyValue(value){
        if (XEClipboard.copy(value)) {
          this.$message.success(this.$t('generic.copySuccess'));
        }
      },


    }
  };
</script>
<style>
  #tableComps .tableComps_header{
    display: flex;
    justify-content: space-between;
    height: auto !important;
    align-items: center;
  }

  .setTableIconClass {
    padding: 5px 0;
    cursor: pointer;
  }
  .setTableIconClass:hover {
    color: #094bff;
  }
  .sortBtnClass {
    cursor: pointer;
    font-size: 12px;
  }
  .sortBtnClass:active {
    color: #409eff;
  }

  .mytable-style .vxe-body--column.col-orange {
    background-color: #8fbc8f;
    color: #fff;
  }

  .vxe-table .vxe-table--fixed-right-wrapper {
    z-index: 99;
  }

  .sortable-row-demo .drag-btn {
    cursor: move;
    font-size: 12px;
  }
  .sortable-row-demo .vxe-body--row.sortable-ghost,
  .sortable-row-demo .vxe-body--row.sortable-chosen {
    background-color: #dfecfb;
  }

  /* Limit every body row to a max height of 30px: clip the cell content when it overflows */
  #tableComps .vxe-table.size--mini .vxe-body--column.col--ellipsis > .vxe-cell {
    max-height: 30px;
    overflow: hidden;
  }

</style>

<style scoped>
  .vxe-table{
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
  }
</style>
